import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export function getPlaidLink(): Promise<any> {
  return fetchWrapper(endpoint + '/v1/plaid/link', {
    method: 'get',
  }).then((res) => res.json());
}

export function reconnectPlaidAccount(id: string): Promise<any> {
  return fetchWrapper(endpoint + '/v1/plaid/reconnect/' + id, {
    method: 'get',
  }).then((res) => res.json());
}
